import React, { useContext } from "react";
import { Tooltip, Space, Button, Badge, Popconfirm, Progress, Typography } from "antd";
import { EditableCell, RowDrag } from "../../../components/table/TableEditAble";
import {
  EditOutlined,
  HolderOutlined,
  PrinterOutlined,
  ExclamationCircleOutlined,
  CloseCircleOutlined,
  QuestionCircleFilled,
} from "@ant-design/icons";
import { TbClockCheck } from "react-icons/tb";
import { FaTruckLoading } from "react-icons/fa";
import dayjs from "dayjs";
import { formatMoney } from "../../../utils/util";
import { TagJoStatus } from "../../../components/badge-and-tag/ERP";

import { docLinkRender } from "../../../components/table/DocLink";
export const componentsEditable = {
  body: { row: RowDrag, cell: EditableCell },
};

const RowContext = React.createContext({});
const DragHandle = () => {
  const { setActivatorNodeRef, listeners } = useContext(RowContext);
  return (
    <Button
      type="text"
      size="small"
      icon={<HolderOutlined />}
      style={{ cursor: "move" }}
      ref={setActivatorNodeRef}
      {...listeners}
    />
  );
};

export const parameterJODetailColumnPrint = [
  {
    title: "Item",
    key: "seq",
    dataIndex: "seq",
    align: "center",
    width: 20,
  },
  {
    title: "รหัส PG",
    width: 130,
    key: "pg_code",
    dataIndex: "pg_code",
    align: "center",
  },
  {
    title: "รหัส FG",
    align: "center",
    width: 80,
    key: "fg_code",
    dataIndex: "fg_code",
  },
  // {
  //   title: "FG Name",
  //   align: "left",
  //   width: 220,
  //   key: "fg_name",
  //   dataIndex: "fg_name",
  // },
  {
    title: "Code",
    align: "center",
    width: 50,
    key: "code",
    dataIndex: "code",
  },

  {
    title: "ชื่อสินค้า",
    align: "left",
    // width: 400,
    key: "pg_name",
    dataIndex: "pg_name",
  },
  {
    // title: "Total Cartons",
    title: "จำนวนกล่อง",
    align: "right",
    width: 50,
    key: "carton",
    dataIndex: "carton",
    render: (t) => formatMoney(Number(t), 0),
  },
  {
    // title: "Unit/Carton",
    title: "Unit/cs",
    align: "right",
    width: 50,
    key: "unit_cs",
    dataIndex: "unit_cs",
    render: (t) => formatMoney(Number(t), 0),
  },
  {
    title: "จำนวน Unit",
    align: "right",
    width: 50,
    key: "total_unit",
    dataIndex: "total_unit",
    render: (t, v) => formatMoney(Number(v.carton) * Number(v.unit_cs), 0),
  },
  {
    title: "Remark",
    align: "right",
    key: "detail_remark",
    dataIndex: "detail_remark",
  },
];

export const accessColumn = ({
  handleApprove,
  handleView,
  handlePrint,
  handlePrintInvoice,
  handleDeliveryNote,
  handleShipped,
}) => [
  {
    title: "รหัส JO",
    dataIndex: "jocode",
    key: "jocode",
    sorter: (a, b) => {
      const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: "base",
      });
      return collator.compare(String(a?.jocode ?? ""), String(b?.jocode ?? ""));
    },
    sortDirections: ["descend", "ascend"],
    width: 80,
    /* กดเลข JO เพื่อเปิดหน้าแสดงข้อมูล */
    render: docLinkRender(handleView, "เปิดดู Job Order"),
  },
  {
    title: "วันที่ JO",
    dataIndex: "jodate",
    key: "jodate",
    width: 100,
    sorter: (a, b) => dayjs(a.jodate || 0).diff(dayjs(b.jodate || 0)),
    render: (v) => dayjs(v).format("DD/MM/YYYY"),
  },
  {
    title: "ชื่อลูกค้า",
    dataIndex: "cusname",
    key: "cusname",
    // width: "25%",
    sorter: (a, b) => (a?.cusname || "").localeCompare(b?.cusname || ""),
    ellipsis: { showTitle: false },
    render: (v) => (
      <Tooltip placement="topLeft" title={v}>
        {v}
      </Tooltip>
    ),
  },
  // {
  //   title: "PG Name",
  //   dataIndex: "pg_code",
  //   key: "pg_code",
  //   width: "20%",
  //   sorter: (a, b) => (a?.pg_code || "").localeCompare(b?.pg_code || ""),
  //   ellipsis: { showTitle: false },
  // },
  // {
  //   title: "FG Name",
  //   dataIndex: "fg_code",
  //   key: "fg_code",
  //   width: "20%",
  //   sorter: (a, b) => (a?.fg_code || "").localeCompare(b?.fg_code || ""),
  //   ellipsis: { showTitle: false },
  // },
  {
    title: "Brand",
    dataIndex: "brand",
    key: "brand",
    width: "15%",
    sorter: (a, b) => (a?.brand || "").localeCompare(b?.brand || ""),
    ellipsis: { showTitle: false },
    render: (v) => (
      <Tooltip placement="topLeft" title={v}>
        {v}
      </Tooltip>
    ),
  },
  {
    title: "ETL",
    dataIndex: "etl",
    key: "etl",
    width: 100,
    sorter: (a, b) => dayjs(a.etl || 0).diff(dayjs(b.etl || 0)),
    render: (t, v) => (!!v?.etl ? dayjs(t).format("DD/MM/YYYY") : ""),
  },

  {
    title: "ETD",
    dataIndex: "etd",
    key: "etd",
    width: 100,
    sorter: (a, b) => dayjs(a.etd || 0).diff(dayjs(b.etd || 0)),
    render: (t, v) => (!!v?.etd ? dayjs(t).format("DD/MM/YYYY") : ""),
  },
  {
    title: "Actual ETD",
    dataIndex: "act_etd",
    key: "act_etd",
    width: 100,
    sorter: (a, b) => dayjs(a.act_etd || 0).diff(dayjs(b.act_etd || 0)),
    render: (t, v) => (!!v?.act_etd ? dayjs(t).format("DD/MM/YYYY") : ""),
  },
  {
    title: "Actual ETL",
    dataIndex: "act_etl",
    key: "act_etl",
    width: 100,
    sorter: (a, b) => dayjs(a.act_etl || 0).diff(dayjs(b.act_etl || 0)),
    render: (t, v) => (!!v?.act_etl ? dayjs(t).format("DD/MM/YYYY") : ""),
  },
  {
    title: "สถานะการผลิต",
    align: "center",
    width: 100,
    key: "doc_status",
    dataIndex: "doc_status",
    sorter: (a, b) => (a?.doc_status || "").localeCompare(b?.doc_status || ""),
    render: (t) => <TagJoStatus result={t} />,
  },
  /* ภาพรวมการส่งของทั้งใบ : ส่งแล้วกี่กล่องจากทั้งหมดกี่กล่อง
     ตัวเลขมาจาก er_jodetail.shipped_carton เทียบกับ carton */
  {
    title: "ส่งแล้ว",
    align: "center",
    width: 150,
    key: "shipped",
    sorter: (a, b) => {
      const pa = Number(a?.total_carton || 0) > 0 ? Number(a?.total_shipped || 0) / Number(a.total_carton) : 0;
      const pb = Number(b?.total_carton || 0) > 0 ? Number(b?.total_shipped || 0) / Number(b.total_carton) : 0;
      return pa - pb;
    },
    render: (_, r) => {
      const total = Number(r?.total_carton || 0);
      const done = Number(r?.total_shipped || 0);
      if (total <= 0) return <Typography.Text type="secondary">-</Typography.Text>;
      const pct = Math.min(100, Math.round((done / total) * 100));
      const full = done >= total;
      const over = Math.round((done - total) * 1000) / 1000;
      /* แสดงทศนิยมเฉพาะเมื่อมี (สูงสุด 3 ตำแหน่ง) */
      const qn = (v) =>
        Number(v || 0).toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 3 });
      return (
        <Tooltip
          title={`ส่งแล้ว ${qn(done)} จาก ${qn(total)} กล่อง${over > 0 ? ` (เกิน ${qn(over)} กล่อง)` : ""}`}
        >
          <div style={{ lineHeight: 1.2 }}>
            <div style={{ fontSize: 12 }}>
              {qn(done)} / {qn(total)}
            </div>
            {over > 0 && (
              <div style={{ fontSize: 11, color: "#d46b08", fontWeight: 600 }}>
                เกิน +{qn(over)}
              </div>
            )}
            <Progress
              percent={pct}
              size="small"
              showInfo={false}
              status={full ? "success" : "active"}
              strokeColor={over > 0 ? "#fa8c16" : undefined}
            />
          </div>
        </Tooltip>
      );
    },
  },
  {
    title: "สถานะส่งออก",
    align: "center",
    width: 100,
    key: "export_status_manual",
    dataIndex: "export_status_manual",
    sorter: (a, b) => (a?.export_status_manual || "").localeCompare(b?.export_status_manual || ""),
    render: (t) => <TagJoStatus result={t} />,
  },
  {
    title: "ตัวเลือก",
    align: "center",
    key: "operation",
    dataIndex: "operation",
    width: "230px",
    fixed: "right",
    render: (text, record) => {
      /* ใบที่ยกเลิกแล้ว เหลือปุ่มดูข้อมูลอย่างเดียว */
      const isCancelled = record.doc_status === "ยกเลิก";
      const canApproveProduction = record.doc_status === "รอดำเนินการ";
      const canApproveExport = record.export_status_manual === "รอดำเนินการ";

      const approvePopconfirmProps =
        canApproveProduction && canApproveExport
          ? {
              okText: "ยืนยันการส่งออก",
              cancelText: "ยืนยันการผลิต",
              showCancel: true,
              onConfirm: () => handleApprove?.(record, "export"),
              onCancel: () => handleApprove?.(record, "production"),
            }
          : canApproveExport
            ? {
                okText: "ยืนยันการส่งออก",
                showCancel: false,
                onConfirm: () => handleApprove?.(record, "export"),
              }
            : {
                okText: "ยืนยันการผลิต",
                okButtonProps: { type: "default" },
                showCancel: false,
                onConfirm: () => handleApprove?.(record, "production"),
              };

      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: ".5rem",
            justifyContent: "start",
          }}
        >
          <Badge size="small" offset={[0, 1]}>
            <Button
              icon={<ExclamationCircleOutlined />}
              className="bn-success-outline"
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onClick={(e) => handleView(record)}
              size="small"
            />
          </Badge>
          {isCancelled ? null : (
          <>
          <Badge size="small" offset={[0, 1]}>
            <Button
              icon={<PrinterOutlined />}
              className="bn-warning-outline"
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onClick={(e) => handlePrint(record)}
              size="small"
            />
          </Badge>
          <Badge size="small" offset={[0, 1]}>
            <Button
              icon={<FaTruckLoading style={{ fontSize: ".85rem" }} />}
              className="bn-info-outline"
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onClick={(e) => handleDeliveryNote?.(record)}
              size="small"
            />
          </Badge>
          </>
          )}
          {/* <Badge size="small" offset={[0, 1]}>
            <Button
              icon={<PrinterOutlined />}
              className="bn-primary-outline"
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onClick={(e) => handlePrintInvoice?.(record)}
              size="small"
            />
          </Badge> */}
          {!isCancelled && (canApproveProduction || canApproveExport) ? (
            <>
              <Badge size="small" offset={[0, 1]}>
                <Popconfirm
                  placement="topRight"
                  title="เลือกการยืนยัน"
                  description={
                    canApproveProduction && canApproveExport
                      ? "ต้องการยืนยันการผลิต หรือยืนยันการส่งออก?"
                      : canApproveExport
                        ? "ต้องการยืนยันการส่งออก?"
                        : "ต้องการยืนยันการผลิต?"
                  }
                  icon={<QuestionCircleFilled />}
                  {...approvePopconfirmProps}
                >
                  <Button
                    // icon={record.cusapproved_status === 'N' ? <TbClockCheck style={{fontSize: '1rem'}} /> : <CloseCircleOutlined />}
                    icon={<TbClockCheck style={{ fontSize: "1rem" }} />}
                    className={`bn-center !text-white !bg-emerald-800 !border-emerald-800`}
                    style={{ cursor: "pointer" }}
                    size="small"
                  />
                </Popconfirm>
              </Badge>
            </>
          ) : null}
        </div>
      );
    },
  },
];

export const detailColumns = ({ handleSave, handleAction }) => {
  return [
    { key: "sort", align: "center", width: 60, render: () => <DragHandle /> },
    // {
    //   title: "No.",
    //   key: "seq",
    //   dataIndex: "seq",
    //   align: "center",
    //   width: 60,
    // },
    {
      title: "PG Code",
      align: "left",
      width: 130,
      key: "pg_code",
      dataIndex: "pg_code",
    },
    {
      title: "PG Name",
      align: "left",
      editable: true,
      required: true,
      key: "pg_name",
      dataIndex: "pg_name",
      type: "select-pg-jo",
    },
    {
      title: "FG Name",
      align: "left",
      key: "fg_name",
      dataIndex: "fg_name",
      width: 180,
    },
    {
      title: "Code",
      align: "left",
      key: "code",
      width: 70,
      dataIndex: "code",
    },
    {
      title: "จำนวนกล่อง",
      align: "right",
      width: 100,
      editable: true,
      required: false,
      key: "carton",
      dataIndex: "carton",
      className: "field-edit pe-2",
      type: "input",
      render: (t) => formatMoney(Number(t), 0),
    },
    {
      title: "Unit/cs",
      align: "right",
      width: 100,
      key: "unit_cs",
      dataIndex: "unit_cs",
      className: "field-edit pe-2",
      type: "input",
      render: (t) => formatMoney(Number(t), 0),
    },
    {
      title: "จำนวน Unit",
      align: "right",
      width: 100,
      key: "total_unit",
      dataIndex: "total_unit",
      className: "field-edit pe-2",
      render: (t, v) => formatMoney(Number(v.carton) * Number(v.unit_cs), 0),
    },
    {
      title: "ราคา/Unit",
      align: "right",
      width: 100,
      editable: true,
      required: false,
      key: "price",
      dataIndex: "price",
      className: "field-edit pe-2",
      type: "input",
      render: (t) => (t != null && t !== "" ? formatMoney(Number(t), 2) : "-"),
    },
    {
      title: "หมายเหตุ",
      align: "center",
      width: 120,
      key: "detail_remark",
      dataIndex: "detail_remark",
      editable: true,
      required: false,
      className: "field-edit pe-2",
      type: "input",
    },
    {
      title: "ตัวเลือก",
      align: "center",
      key: "operation",
      dataIndex: "operation",
      render: (_, record) => handleAction(record),
      width: "90px",
      fixed: "right",
    },
  ].filter((item) => !item.hidden);
};

export const remarkColumns = ({ handleSave, handleActionRemark }) => {
  return [
    {
      title: "ลำดับ",
      key: "seq",
      dataIndex: "seq",
      align: "center",
      width: 80,
    },
    {
      title: "ข้อกำหนดพิเศษ",
      key: "remark_detail",
      dataIndex: "remark_detail",
      align: "left",
      editable: true,
      required: false,
      className: "field-edit pe-2",
      type: "input",
    },
    {
      title: "ตัวเลือก",
      align: "center",
      key: "operation",
      dataIndex: "operation",
      render: (_, record) => handleActionRemark(record),
      width: "90px",
      fixed: "right",
    },
  ];
};

export const columnsDetailsEditable = (
  handleSave,
  handleModalSelect,
  optionsPGforJo,
  { handleAction },
) => {
  const col = detailColumns({ handleAction });
  return col.map((c) => {
    if (!c.editable) return c;
    return {
      ...c,
      onCell: (record) => ({
        record,
        editable: c.editable,
        dataIndex: c.dataIndex,
        title: c.title,
        handleSave,
        fieldType: !!c.textArea,
        required: !!c.required,
        type: c.type || "input",
        autocompleteOption: c.autocompleteOption,
        modalSelect: handleModalSelect,
        optionsPGforJo,
      }),
    };
  });
};

export const columnsRemarkEditable = (handleSave, { handleActionRemark }) => {
  const col = remarkColumns({ handleActionRemark });
  return col.map((c) => {
    if (!c.editable) return c;
    return {
      ...c,
      onCell: (record) => ({
        record,
        editable: c.editable,
        dataIndex: c.dataIndex,
        title: c.title,
        handleSave,
        fieldType: !!c.textArea,
        required: !!c.required,
        type: c.type || "input",
        autocompleteOption: c.autocompleteOption,
      }),
    };
  });
};

export const detailColumnsView = ({ PrintDetail }) => [
  {
    title: "Item",
    key: "seq",
    dataIndex: "seq",
    align: "center",
    width: 60,
  },
  {
    title: "PG",
    width: 100,
    key: "pg_code",
    dataIndex: "pg_code",
  },
  {
    title: "PG Name",
    align: "center",
    key: "pg_name",
    dataIndex: "pg_name",
  },
  {
    title: "FG",
    align: "center",
    key: "fg_code",
    width: 100,
    dataIndex: "fg_code",
  },
  {
    title: "FG Name",
    align: "center",
    key: "fg_name",
    width: 300,
    dataIndex: "fg_name",
  },
  {
    title: "Product Code",
    align: "center",
    width: 60,
    key: "code",
    dataIndex: "code",
  },
  {
    title: "Unit/Carton",
    align: "right",
    width: 60,
    key: "unit_cs",
    dataIndex: "unit_cs",
    render: (t) => formatMoney(Number(t), 0),
  },
  {
    title: "Total Cartons",
    align: "right",
    width: 60,
    key: "carton",
    dataIndex: "carton",
    render: (t) => formatMoney(Number(t), 0),
  },
  {
    title: "Total Units",
    align: "right",
    width: 60,
    key: "total_units",
    render: (_, r) =>
      Number((r.carton || 0) * (r.unit_cs || 0)).toLocaleString("en-US"),
  },
  {
    title: "ผลิตแล้ว",
    align: "right",
    width: 80,
    key: "total_pd",
    dataIndex: "total_pd",
    render: (t, r) => {
      const produced = Number(t || 0);
      const totalUnit = Number(r.carton || 0) * Number(r.unit_cs || 0);
      if (produced <= 0) return <span style={{ color: "#bfbfbf" }}>-</span>;
      const done = totalUnit > 0 && produced >= totalUnit;
      return (
        <span style={{ color: done ? "#52c41a" : "#1677ff", fontWeight: 600 }}>
          {produced.toLocaleString("en-US")}
        </span>
      );
    },
  },
  {
    title: "สถานะการผลิต",
    align: "center",
    width: 100,
    key: "production_status",
    dataIndex: "production_status",
  },
  {
    title: "สถานะปิดฉลาก",
    align: "center",
    width: 100,
    key: "label_status",
    dataIndex: "label_status",
  },
  {
    title: "หมายเหตุ",
    align: "left",
    key: "detail_remark",
    dataIndex: "detail_remark",
  },
  {
    title: "ตัวเลือก",
    align: "center",
    key: "operation",
    dataIndex: "operation",
    width: "30px",
    fixed: "right",
    render: (text, record) => {
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: ".5rem",
            justifyContent: "center",
          }}
        >
          <Badge size="small" offset={[0, 1]}>
            <Button
              icon={<PrinterOutlined />}
              className="bn-warning-outline"
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onClick={(e) => PrintDetail(record)}
              size="small"
            />
          </Badge>
        </div>
      );
    },
  },
];

export const remarkColumnsView = [
  {
    title: "ลำดับ",
    key: "seq",
    dataIndex: "seq",
    align: "center",
    width: 80,
  },
  {
    title: "ข้อกำหนดพิเศษ",
    key: "remark_detail",
    dataIndex: "remark_detail",
    align: "left",
  },
];

export const Product = {
  id: null,
  product_code: null,
  product_name: null,
  product_nameEN: null,
  product_type: null,
  product_stname_cus: null,
  code: null,
  unit: null,
  weight_nw: 0,
  weight_gw: 0,
  feature: null,
  remarks: null,
  active_status: null,
};
